module.exports = __webpack_public_path__ + "static/media/stars.1d913893.svg";